interface Discount {
  id: string
  code: string
  description: string
  type: 'fixed' | 'percentage'
  quantity: number
  store_ids: string[]
  target: 'all_products' | 'product_variant'
  trigger: 'manual' | 'automatic'
  quantity_per_customer: number
  published_at: string | null
  start_date: string | null
  end_date: string | null
}

export enum DiscountType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  LOYALTY = 'LOYALTY'
}

export enum DiscountFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SCHEDULED = 'SCHEDULED'
}

export type { Discount }
